import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DoneIcon from "@mui/icons-material/Done";
import Loader from "../../components/loader/Loader";
import { apiBaseURL } from "../../utils/axios";
// import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";

const Verified = () => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errCheck, setErrCheck] = useState("");

  useEffect(() => {
    axios({
      method: "get",
      url: `${apiBaseURL}/v1/auth/verify/email/${id}/${token}`,
    })
      .then((response) => {
        setLoading(false);
        setIsVerified(true);
      })
      .catch((error) => {
        setLoading(false);
        setIsVerified(false);
        setErrorMessage(
          error?.response?.data?.message || "Email Verification failed"
        );
        setErrCheck(errorMessage);
      });
  }, [id, token, errorMessage, errCheck]);

  // Handle button click to navigate to login page
  const handleLoginClick = () => {
    navigate("/auth");
  };

  // Render loading or verification success/failure components
  return (
    <div className="flex flex-col items-center justify-center h-screen px-4 bg-slate-200">
      {loading && <Loader />}
      {!loading && isVerified && (
        <div className="shadow-xl p-12 text-center max-w-md rounded-lg bg-white">
          <div className="flex justify-center items-center self-center">
            <div className="rounded-full border-4 border-[#2e7d32] h-12 w-12 flex justify-center items-center self-center">
              <DoneIcon color="success" fontSize="large" />
            </div>
          </div>
          <h4 className="text-green-500 text-2xl font-semibold my-4">
            Email Verified Successfully!
          </h4>
          <button
            onClick={handleLoginClick}
            className="mt-4 bg-green-500 text-white px-5 py-3 rounded-md hover:bg-green-600"
          >
            Go to Login
          </button>
        </div>
      )}
      {!loading && !isVerified && (
        <div className="shadow-xl p-12 text-center max-w-md rounded-lg bg-white">
          <HighlightOffIcon color="warning" fontSize="large" />

          <h4 className="text-red-500 text-2xl font-semibold my-4">Oops</h4>

          <p className="text-slate-500"> {errorMessage}</p>

          {errCheck === "Email Verification failed" ? (
            <button
              onClick={() => window.location.reload()}
              className="my-4 bg-red-500 hover:bg-red-600 text-white px-5 py-3 rounded-md"
            >
              Try Again
            </button>
          ) : (
            <button
              onClick={handleLoginClick}
              className="my-4 bg-red-500 hover:bg-red-600 text-white px-5 py-3 rounded-md"
            >
              Go to Login
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Verified;
